/* DT · Tufting-assistent (gedeeld script voor het homepagepaneel en de pop-up op elke pagina).
   - Praat met de Edge Function (data-endpoint), demo-modus zonder endpoint.
   - Links uit antwoorden krijgen het taalpad van de bezoeker (Shopify.routes.root).
   - Productlinks worden productkaarten met foto, prijs en winkelwagenknop; meerdere uitvoeringen → keuzevenster.
   - Elke link naar #tufting-assistent of element met [data-dt-open-chat] opent de assistent.
   - Hulp & contact: [data-dt-contact="whatsapp|callback|email"]. Geen balk bovenaan en geen route "bellen".
     De contactkaart verschijnt bij [[#contact]] of als de klant na het eerste antwoord "Nee" kiest.
     Tufty: alleen de zwevende knop speelt video. FAQ-kaart en menulink animeren de poster in CSS.
     In het mobiele menu (geen mega-menu) zet decorateHelpTufty dezelfde poster naast de hulp-link. */
(function () {
  if (window.DTChat) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HISTORY_KEY = 'dt-chat-history';
  var SESSION_KEY = 'dt-chat-session';

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function localUrl(url) {
    if (!url || url.charAt(0) !== '/') return url;
    var root = ROOT.replace(/\/$/, '');
    if (!root || url.indexOf(root + '/') === 0) return url;
    return root + url;
  }
  function render(text) {
    var h = esc(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\n{2,}/g, '</p><p>').replace(/\n/g, '<br>');
    return '<p>' + h + '</p>';
  }
  function session() {
    var s = null;
    try { s = sessionStorage.getItem(SESSION_KEY); if (!s) { s = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()); sessionStorage.setItem(SESSION_KEY, s); } } catch (e) { s = String(Date.now()); }
    return s;
  }
  function moneyFmt(cents, lang) {
    try { return new Intl.NumberFormat(lang || document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); } catch (e) { return '€' + (cents / 100).toFixed(2); }
  }
  function svg(name) {
    if (name === 'cart') return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.2L20.5 8H6.1"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';
    if (name === 'check') return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7"/></svg>';
    if (name === 'close') return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    return '';
  }

  /* ---------- Hulp & contact ---------- */
  var GCLID_KEY = 'dt-gclid', NUDGE_KEY = 'dt-nudge';
  (function captureGclid() {
    try { var m = location.search.match(/[?&](gclid|gbraid|wbraid)=([^&#]+)/); if (m) localStorage.setItem(GCLID_KEY, JSON.stringify({ v: decodeURIComponent(m[2]), t: Date.now() })); } catch (e) {}
  })();
  function gclid() { try { var g = JSON.parse(localStorage.getItem(GCLID_KEY) || 'null'); if (g && Date.now() - g.t < 90 * 864e5) return g.v; } catch (e) {} return ''; }
  function teamCfg() { return document.querySelector('[data-dt-team]'); }
  function teamStrip(opts) {
    var t = document.querySelector('[data-dt-team-tpl]');
    var node = (t && t.content && t.content.firstElementChild) ? t.content.firstElementChild.cloneNode(true) : null;
    if (!node) return null;
    node.querySelectorAll('[data-dt-contact="phone"]').forEach(function (b) { b.remove(); });
    if (opts && opts.heading) {
      var title = node.querySelector('.dt-team__title');
      if (title) title.textContent = opts.heading;
    }
    return node;
  }
  function track(method, extra) {
    var p = { method: method, page: location.pathname }; for (var k in (extra || {})) p[k] = extra[k];
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'dt_contact', dt_contact_method: method, page_path: location.pathname }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dt_contact', p); } catch (e) {}
  }
  function waUrl() {
    var c = teamCfg(); if (!c || !c.dataset.wa) return null;
    var msg = (c.dataset.waMessage || '').replace('{url}', location.origin + location.pathname);
    return 'https://wa.me/' + c.dataset.wa + (msg ? '?text=' + encodeURIComponent(msg) : '');
  }
  var HELPED_KEY = 'dt-chat-helped';
  function helpedFlag() { try { return sessionStorage.getItem(HELPED_KEY) || ''; } catch (e) { return ''; } }
  function setHelped(v) { try { sessionStorage.setItem(HELPED_KEY, v); } catch (e) {} }
  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function tuftyCanWebm() {
    var probe = document.createElement('video');
    return !!(probe.canPlayType('video/webm; codecs="vp9"') || probe.canPlayType('video/webm; codecs="vp09.00.10.08"'));
  }
  var tuftySeen = false;
  function tuftyBox() { return document.querySelector('button.dt-chat-fab .dt-tufty'); }
  function tuftyWant() {
    if (reduceMotion() || document.hidden) return false;
    if (document.documentElement.classList.contains('dt-chat-open')) return false;
    return tuftySeen;
  }
  function tuftySync() {
    var box = tuftyBox(); if (!box) return;
    var video = box.querySelector('.dt-tufty__vid');
    var anim = box.querySelector('.dt-tufty__anim');
    if (reduceMotion()) { box.classList.add('is-still'); box.classList.remove('is-play', 'is-anim'); return; }
    if (!tuftyCanWebm()) {
      box.classList.remove('is-play');
      if (!tuftyWant()) {
        box.classList.remove('is-anim');
        if (anim) anim.removeAttribute('src');
        return;
      }
      var goAnim = function () {
        if (!anim) return;
        if (!anim.getAttribute('src')) anim.src = anim.getAttribute('data-src');
        box.classList.add('is-anim');
      };
      if (!anim || anim.getAttribute('src')) goAnim();
      else if ('requestIdleCallback' in window) requestIdleCallback(goAnim, { timeout: 1200 });
      else goAnim();
      return;
    }
    if (!video) return;
    if (!tuftyWant()) { box.classList.remove('is-play'); if (!video.paused) video.pause(); return; }
    var start = function () {
      if (video.__dtLoaded) {
        box.classList.add('is-play');
        var again = video.play(); if (again && again.catch) again.catch(function () {});
        return;
      }
      video.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
      video.__dtLoaded = true;
      video.load();
      var play = function () {
        if (!tuftyWant()) return;
        box.classList.add('is-play');
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      };
      if (video.readyState >= 2) play();
      else video.addEventListener('canplay', play, { once: true });
    };
    if (video.__dtLoaded) { start(); return; }
    if (video.__dtQueued) return;
    video.__dtQueued = true;
    var go = function () { video.__dtQueued = false; if (tuftyWant()) start(); };
    // 17-10-2026: video pas na het load-event laden; in Safari/WebKit hield video.load() het load-event tegen (app-scripts laadden niet).
    if (document.readyState !== 'complete') { window.addEventListener('load', function () { setTimeout(go, 300); }, { once: true }); return; }
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 800 });
    setTimeout(go, 700);
  }
  function armTufty() {
    var box = tuftyBox(); if (!box || box.__dtArmed) { tuftySync(); return; }
    box.__dtArmed = true;
    var video = box.querySelector('.dt-tufty__vid');
    if (video) video.addEventListener('error', function () { box.classList.add('is-still'); box.classList.remove('is-play'); });
    // 27-10-2026: poster pas verbergen als er echt beeld is; anders schemerde hij door de transparante video heen (dubbele Tufty).
    if (video) video.addEventListener('playing', function () { box.classList.add('is-live'); });
    var animImg = box.querySelector('.dt-tufty__anim');
    if (animImg) animImg.addEventListener('load', function () { box.classList.add('is-live'); });
    var mark = function (on) { tuftySeen = on; tuftySync(); };
    var inView = function () {
      var r = box.getBoundingClientRect();
      return r.width > 0 && r.bottom > -80 && r.top < window.innerHeight + 80;
    };
    if (!video || !('IntersectionObserver' in window)) { mark(true); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { mark(en.isIntersecting); });
    }, { rootMargin: '80px' });
    io.observe(box);
    mark(inView());
  }
  function decorateHelpTufty() {
    var host = document.querySelector('[data-tufty-poster]');
    var src = host ? host.getAttribute('data-tufty-poster') : '';
    if (!src) {
      var still = document.querySelector('button.dt-chat-fab .dt-tufty__still');
      src = still ? still.getAttribute('src') : '';
    }
    if (!src) return;
    document.querySelectorAll('#header-sidebar-menu a[href*="#tufting-assistent"], .navigation-drawer a[href*="#tufting-assistent"]').forEach(function (a) {
      if (a.querySelector('.dt-tufty') || a.closest('.dt-mm')) return;
      var box = document.createElement('span');
      box.className = 'dt-tufty dt-tufty--idle dt-tufty--spot';
      box.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.className = 'dt-tufty__still';
      img.alt = '';
      img.width = 44;
      img.height = 44;
      img.decoding = 'async';
      img.src = src;
      box.appendChild(img);
      a.classList.add('dt-help-link');
      a.insertBefore(box, a.firstChild);
    });
  }
  function transcript() {
    var h = null; try { h = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || 'null'); } catch (e) {}
    if (!h || !h.length) return '';
    var out = h.slice(-10).map(function (m) { return (m.role === 'user' ? 'Klant: ' : 'Assistent: ') + String(m.content || '').replace(/\s+/g, ' ').trim(); }).join('\n');
    return out.length > 1800 ? '…' + out.slice(-1800) : out;
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(ROOT.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); });
    }
    return productCache[handle];
  }
  function addToCart(variantId) {
    return fetch(ROOT.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d && (d.description || d.message) || 'cart'); return d; }); })
      .then(function (d) { document.dispatchEvent(new CustomEvent('cart:refresh')); return d; });
  }
  function openCart() {
    var t = document.querySelector('[aria-controls="cart-drawer"]');
    if (t) { t.click(); return; }
    location.href = ROOT.replace(/\/$/, '') + '/cart';
  }

  function Chat(panel) {
    this.panel = panel;
    this.d = panel.dataset;
    this.log = panel.querySelector('[data-dt-log]');
    this.form = panel.querySelector('[data-dt-form]');
    this.input = panel.querySelector('[data-dt-input]');
    this.busy = false;
    this.history = [];
    this.session = session();
    var self = this;
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.ask(self.input.value); });
    var scope = panel.closest('[data-dt-chat-scope]') || panel.parentNode;
    scope.querySelectorAll('[data-dt-suggest]').forEach(function (b) {
      b.addEventListener('click', function () { self.ask(b.textContent); self.input.focus({ preventScroll: true }); });
    });
    this.restore();
  }
  Chat.prototype.persist = function () {
    try { sessionStorage.setItem(HISTORY_KEY, JSON.stringify(this.history.slice(-12))); } catch (e) {}
  };
  Chat.prototype.restore = function () {
    var h = null;
    try { h = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || 'null'); } catch (e) {}
    if (!h || !h.length) return;
    var self = this;
    h.forEach(function (m) { self.history.push(m); self.add(m.role === 'user' ? 'user' : 'bot', m.content, m.links || [], true); });
    if (h.some(function (m) { return m.role !== 'user'; }) && !helpedFlag()) setHelped('seen');
  };
  Chat.prototype.add = function (role, text, links, quiet) {
    var wrap = document.createElement('div');
    wrap.className = 'dt-chat__msg dt-chat__msg--' + role;
    if (role === 'user') this.panel.classList.add('has-convo');
    var body = document.createElement('div');
    body.className = 'dt-chat__msgbody';
    var b = document.createElement('div');
    b.className = 'dt-chat__bubble';
    b.innerHTML = role === 'bot' ? render(text) : '<p>' + esc(text) + '</p>';
    body.appendChild(b);
    if (role === 'bot') {
      var av = document.createElement('span');
      av.className = 'dt-tufty dt-tufty--msg';
      av.setAttribute('aria-hidden', 'true');
      var poster = (teamCfg() && teamCfg().dataset.tuftyPoster) || '';
      if (!poster) { var still = document.querySelector('.dt-tufty__still'); poster = still ? still.getAttribute('src') : ''; }
      if (poster) av.innerHTML = '<img class="dt-tufty__still" src="' + esc(poster) + '" alt="" width="40" height="40" decoding="async">';
      wrap.classList.add('dt-chat__msg--withav');
      wrap.appendChild(av);
    }
    wrap.appendChild(body);
    var pages = [], products = [];
    var wantsTeam = false;
    (links || []).slice(0, 5).forEach(function (l) {
      if (l && l.url === '#contact') { wantsTeam = true; return; }
      if (!l || !l.url || l.url.charAt(0) !== '/') return;
      var m = l.url.match(/^\/products\/([a-z0-9\-]+)/i);
      if (m) products.push({ handle: m[1], title: l.title }); else pages.push(l);
    });
    if (products.length) {
      var list = document.createElement('div');
      list.className = 'dt-chat__products';
      body.appendChild(list);
      var self = this;
      products.slice(0, 3).forEach(function (p) { self.productCard(list, p); });
    }
    if (pages.length) {
      var ul = document.createElement('ul');
      ul.className = 'dt-chat__links';
      pages.forEach(function (l) {
        var li = document.createElement('li'); var a = document.createElement('a');
        a.href = localUrl(l.url); a.textContent = l.title || l.url; li.appendChild(a); ul.appendChild(li);
      });
      body.appendChild(ul);
    }
    if (wantsTeam) {
      if (!helpedFlag()) setHelped('contact');
      var strip = teamStrip();
      if (strip) { strip.classList.add('dt-team--msg'); body.appendChild(strip); }
    }
    this.log.appendChild(wrap);
    if (!quiet) this.log.scrollTop = this.log.scrollHeight;
    return wrap;
  };
  Chat.prototype.offerHelp = function () {
    if (helpedFlag() || this.log.querySelector('[data-dt-helped]')) return;
    setHelped('shown');
    var c = (teamCfg() && teamCfg().dataset) || {};
    var box = document.createElement('div');
    var qid = 'dt-helped-' + this.session.slice(0, 8);
    box.className = 'dt-helped';
    box.setAttribute('data-dt-helped', '');
    box.setAttribute('role', 'group');
    box.setAttribute('aria-labelledby', qid);
    box.innerHTML = '<p class="dt-helped__q" id="' + qid + '">' + esc(c.helpedQ || 'Heeft dit je geholpen?') + '</p>'
      + '<div class="dt-helped__btns">'
      + '<button type="button" class="dt-helped__btn" data-dt-helped-yes>' + esc(c.helpedYes || 'Ja') + '</button>'
      + '<button type="button" class="dt-helped__btn" data-dt-helped-no>' + esc(c.helpedNo || 'Nee') + '</button>'
      + '</div>';
    this.log.appendChild(box);
    this.log.scrollTop = this.log.scrollHeight;
  };
  Chat.prototype.productCard = function (list, info) {
    var d = this.d, self = this;
    var card = document.createElement('div');
    card.className = 'dt-chat__product is-loading';
    card.innerHTML = '<span class="dt-chat__pimg"></span><span class="dt-chat__pbody"><a class="dt-chat__ptitle" href="' + esc(localUrl('/products/' + info.handle)) + '">' + esc(info.title || '') + '</a><span class="dt-chat__pprice"></span></span>';
    list.appendChild(card);
    fetchProduct(info.handle).then(function (p) {
      card.classList.remove('is-loading');
      var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
      if (img) card.querySelector('.dt-chat__pimg').innerHTML = '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" width="64" height="64" loading="lazy">';
      card.querySelector('.dt-chat__ptitle').textContent = p.title;
      var price = card.querySelector('.dt-chat__pprice');
      var varies = p.price_min !== p.price_max;
      price.textContent = (varies ? (d.fromLabel || 'vanaf') + ' ' : '') + moneyFmt(p.price_min);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dt-chat__padd';
      btn.innerHTML = svg('cart') + '<span class="dt-vh">' + esc(d.addLabel || 'In winkelwagen') + '</span>';
      btn.title = d.addLabel || 'In winkelwagen';
      if (!p.available) { btn.disabled = true; btn.title = d.soldoutLabel || 'Uitverkocht'; price.textContent += ' · ' + (d.soldoutLabel || 'Uitverkocht'); }
      btn.addEventListener('click', function () {
        var avail = p.variants.filter(function (v) { return v.available; });
        if (p.variants.length === 1 || avail.length === 1) self.doAdd(btn, (avail[0] || p.variants[0]).id, p.title);
        else self.chooser(card, p);
      });
      card.appendChild(btn);
    }).catch(function () { card.classList.remove('is-loading'); card.classList.add('is-error'); });
  };
  Chat.prototype.doAdd = function (btn, variantId, title) {
    var d = this.d, self = this;
    btn.disabled = true; btn.classList.add('is-busy');
    addToCart(variantId).then(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.innerHTML = svg('check') + '<span class="dt-vh">' + esc(d.addedText || 'Toegevoegd') + '</span>';
      var note = document.createElement('div');
      note.className = 'dt-chat__added';
      note.setAttribute('role', 'status');
      note.innerHTML = '<span>' + svg('check') + esc((d.addedText || 'Toegevoegd aan je winkelwagen')) + '</span> <button type="button">' + esc(d.viewCart || 'Bekijk winkelwagen') + '</button>';
      note.querySelector('button').addEventListener('click', function () { if (window.DTChat && DTChat.closeDialog) DTChat.closeDialog(); openCart(); });
      self.log.appendChild(note); self.log.scrollTop = self.log.scrollHeight;
      setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = svg('cart') + '<span class="dt-vh">' + esc(d.addLabel || 'In winkelwagen') + '</span>'; }, 2500);
    }).catch(function (e) {
      btn.disabled = false; btn.classList.remove('is-busy');
      self.add('bot', (e && e.message) || d.error || 'Er ging iets mis.');
    });
  };
  Chat.prototype.chooser = function (card, p) {
    var d = this.d, self = this;
    var old = this.panel.querySelector('.dt-chat__chooser');
    if (old) old.remove();
    var box = document.createElement('div');
    box.className = 'dt-chat__chooser';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', d.chooseLabel || 'Kies een uitvoering');
    var html = '<div class="dt-chat__chead"><p>' + esc(d.chooseLabel || 'Kies een uitvoering') + '</p><button type="button" class="dt-chat__cclose" aria-label="' + esc(d.closeLabel || 'Sluiten') + '">' + svg('close') + '</button></div>';
    html += '<p class="dt-chat__ctitle">' + esc(p.title) + '</p>';
    p.options.forEach(function (o, i) {
      html += '<fieldset class="dt-chat__copt"><legend>' + esc(o.name) + '</legend><div class="dt-chat__cvals">';
      o.values.forEach(function (val, j) {
        html += '<label><input type="radio" name="dt-opt-' + i + '" value="' + esc(val) + '"' + (j === 0 ? ' checked' : '') + '><span>' + esc(val) + '</span></label>';
      });
      html += '</div></fieldset>';
    });
    html += '<div class="dt-chat__cfoot"><span class="dt-chat__cprice"></span><button type="button" class="dt-btn dt-btn--primary dt-chat__cadd">' + svg('cart') + '<span>' + esc(d.addLabel || 'In winkelwagen') + '</span></button></div>';
    box.innerHTML = html;
    this.panel.appendChild(box);
    var priceEl = box.querySelector('.dt-chat__cprice'), addBtn = box.querySelector('.dt-chat__cadd');
    function current() {
      var sel = p.options.map(function (o, i) { var c = box.querySelector('input[name="dt-opt-' + i + '"]:checked'); return c ? c.value : null; });
      return p.variants.filter(function (v) { return sel.every(function (s, i) { return v.options[i] === s; }); })[0];
    }
    function update() {
      var v = current();
      if (!v) { priceEl.textContent = '–'; addBtn.disabled = true; return; }
      priceEl.textContent = moneyFmt(v.price) + (v.available ? '' : ' · ' + (d.soldoutLabel || 'Uitverkocht'));
      addBtn.disabled = !v.available;
    }
    box.addEventListener('change', update);
    box.querySelector('.dt-chat__cclose').addEventListener('click', function () { box.remove(); });
    addBtn.addEventListener('click', function () { var v = current(); if (!v) return; box.remove(); self.doAdd(card.querySelector('.dt-chat__padd'), v.id, p.title); });
    update();
    var first = box.querySelector('input'); if (first) first.focus();
  };
  Chat.prototype.typing = function (on) {
    var t = this.log.querySelector('.dt-chat__typing');
    if (on && !t) {
      t = document.createElement('div'); t.className = 'dt-chat__msg dt-chat__msg--bot dt-chat__typing';
      t.innerHTML = '<div class="dt-chat__bubble" aria-label="…"><span></span><span></span><span></span></div>';
      this.log.appendChild(t); this.log.scrollTop = this.log.scrollHeight;
    } else if (!on && t) { t.remove(); }
  };
  Chat.prototype.ask = function (q) {
    q = (q || '').trim();
    if (!q || this.busy) return;
    var d = this.d, self = this;
    this.busy = true; this.input.value = ''; this.panel.classList.add('is-busy');
    this.add('user', q);
    this.history.push({ role: 'user', content: q });
    this.typing(true);
    var done = function () { self.busy = false; self.panel.classList.remove('is-busy'); self.persist(); };
    if (!d.endpoint) {
      setTimeout(function () {
        self.typing(false);
        var links = [{ title: d.faqTitle || 'FAQ', url: '/pages/veelgestelde-vragen' }, { title: d.contactTitle || 'Contact', url: '/pages/contact' }];
        self.add('bot', d.demo || '…', links);
        self.history.push({ role: 'assistant', content: d.demo || '', links: links });
        if (!helpedFlag()) self.offerHelp();
        done();
      }, 600);
      return;
    }
    fetch(d.endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session: this.session, locale: d.locale, page: location.pathname, messages: this.history.slice(-12).map(function (m) { return { role: m.role, content: m.content }; }) })
    }).then(function (r) { if (!r.ok && r.status !== 429) throw new Error('http ' + r.status); return r.json(); })
      .then(function (res) {
        self.typing(false);
        var reply = (res && res.reply) ? String(res.reply) : (d.error || 'Er ging iets mis.');
        var links = (res && res.links) || [];
        self.history.push({ role: 'assistant', content: reply, links: links });
        self.add('bot', reply, links);
        var hasContact = (links || []).some(function (l) { return l && l.url === '#contact'; });
        if (!hasContact && !helpedFlag()) self.offerHelp();
      })
      .catch(function () { self.typing(false); self.add('bot', d.error || 'Er ging iets mis. Probeer het zo nog eens, of neem contact op.', [{ url: '#contact' }]); if (!helpedFlag()) setHelped('contact'); })
      .then(done);
  };

  var instances = [];
  function init(root) {
    document.querySelectorAll('[data-dt-cform]').forEach(function (f) { bindSubmit(f); });
    (root || document).querySelectorAll('[data-dt-chat]').forEach(function (panel) {
      if (panel.__dtChat) return;
      panel.__dtChat = new Chat(panel);
      instances.push(panel.__dtChat);
    });
  }

  /* Pop-up */
  var dialog = null, lastFocus = null;
  function openDialog(noFocus) {
    dialog = dialog || document.querySelector('[data-dt-chat-dialog]');
    if (!dialog) return false;
    opened = true; markNudged();
    if (dialog.hidden) lastFocus = document.activeElement;
    dialog.hidden = false;
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });
    document.documentElement.classList.add('dt-chat-open');
    tuftySync();
    var input = dialog.querySelector('[data-dt-input]'); if (input && !noFocus) setTimeout(function () { input.focus(); }, 120);
    return true;
  }
  var activeSheet = null, opened = false;
  function showSheet(kind) {
    var box = dialog && dialog.querySelector('.dt-chat-dialog__box'); if (!box) return;
    var sh = box.querySelector('[data-dt-sheet="' + kind + '"]'); if (!sh) return;
    hideSheet(true);
    var form = sh.querySelector('[data-dt-cform]'); if (form) prepForm(form, sh);
    sh.hidden = false; activeSheet = sh; box.classList.add('has-sheet');
    requestAnimationFrame(function () { sh.classList.add('is-open'); });
    var f = sh.querySelector('.dt-cform:not([hidden]) input:not([type=hidden]), .dt-sheet__bignum') || sh;
    setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 80);
    track(kind + '_open');
  }
  function hideSheet(quiet) {
    if (!activeSheet) return;
    var sh = activeSheet, box = sh.parentNode; activeSheet = null;
    sh.classList.remove('is-open'); sh.hidden = true; box.classList.remove('has-sheet');
    if (!quiet) { var i = box.querySelector('[data-dt-input]'); if (i) i.focus({ preventScroll: true }); }
  }
  function contact(kind) {
    if (kind === 'phone') return;
    if (kind === 'whatsapp') { var u = waUrl(); if (u) { track('whatsapp'); window.open(u, '_blank', 'noopener'); } return; }
    if (!dialog || dialog.hidden) openDialog(true);
    showSheet(kind);
  }
  function fill(form) {
    var c = teamCfg() || { dataset: {} }, kind = form.getAttribute('data-dt-cform');
    var set = function (n, v) { var el = form.querySelector('[data-dt-f="' + n + '"]'); if (el) el.value = v || ''; };
    set('type', kind === 'callback' ? c.dataset.typeCallback : c.dataset.typeEmail);
    set('page', location.href.split('#')[0]);
    set('gclid', gclid());
    var box = form.querySelector('[data-dt-transcript]');
    set('transcript', (box && box.checked) ? transcript() : '');
  }
  function prepForm(form, sh) {
    bindSubmit(form);
    var done = sh.querySelector('[data-dt-done]');
    if (done && !done.hidden) { done.hidden = true; form.hidden = false; form.reset(); }
    var st = form.querySelector('[data-dt-status]'); if (st) { st.textContent = ''; st.classList.remove('is-error'); }
    var wrap = form.querySelector('[data-dt-transcript-wrap]'); if (wrap) wrap.hidden = !transcript();
    fill(form);
  }
  function fieldError(input, msg) {
    var err = document.getElementById(input.getAttribute('aria-describedby'));
    if (msg) { input.setAttribute('aria-invalid', 'true'); if (err) { err.textContent = msg; err.hidden = false; } }
    else { input.removeAttribute('aria-invalid'); if (err) { err.textContent = ''; err.hidden = true; } }
  }
  function validate(form) {
    var c = (teamCfg() || { dataset: {} }).dataset, first = null;
    form.querySelectorAll('input:not([type=hidden]):not([type=checkbox]), textarea:not([name*="captcha"]):not([name*="recaptcha"])').forEach(function (el) {
      var v = el.value.trim(), msg = '';
      if (el.required && !v) msg = c.required || 'Vul dit veld in.';
      else if (v && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = c.invalidEmail || 'Vul een geldig e-mailadres in.';
      else if (v && el.type === 'tel' && (v.replace(/\D/g, '').length < 8 || !/^[0-9+()\s.\-]+$/.test(v))) msg = c.invalidPhone || 'Vul een geldig telefoonnummer in.';
      fieldError(el, msg); if (msg && !first) first = el;
    });
    if (first) first.focus();
    return !first;
  }

  /* Verzenden. Shopify beveiligt contactformulieren met een onzichtbare hCaptcha: het Shopify-script vangt de submit af,
     haalt een token op en roept daarna de submit-functie van het formulier aan. Die functie zetten we (vóór Shopify het
     formulier koppelt) op sendNow: dan versturen we het formulier mét token zelf via fetch en lezen we Shopify's echte
     antwoord (contact_posted=true), zonder dat de bezoeker de pagina verlaat. Winkelpagina's mogen niet in een iframe
     (X-Frame-Options: DENY), daarom geen iframe. */
  function bindSubmit(form) {
    if (form.__dtSubmitBound) return;
    form.__dtSubmitBound = true;
    form.__dtLateBind = !!form.getAttribute('data-hcaptcha-bound');
    try { form.submit = function () { sendNow(form); }; } catch (e) {}
  }
  function setSending(form, on) {
    var c = (teamCfg() || { dataset: {} }).dataset, st = form.querySelector('[data-dt-status]'), btn = form.querySelector('[data-dt-submit]');
    form.__dtSending = on; form.classList.toggle('is-sending', on);
    if (btn) { if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled'); }
    if (st && on) { st.textContent = c.sending || '…'; st.classList.remove('is-error'); }
  }
  function challengeOpen() {
    return [].some.call(document.querySelectorAll('iframe[src*="hcaptcha.com"]'), function (f) {
      var r = f.getBoundingClientRect(), cs = getComputedStyle(f);
      return r.width > 150 && r.height > 150 && cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity > 0;
    });
  }
  function guard(form) {
    clearInterval(form.__dtGuard);
    var started = Date.now();
    form.__dtGuard = setInterval(function () {
      if (!form.__dtSending || form.__dtPosting) { clearInterval(form.__dtGuard); return; }
      if (challengeOpen()) { started = Date.now(); return; }
      if (Date.now() - started > 40000) { clearInterval(form.__dtGuard); finishSend(form, false); }
    }, 300);
  }
  function sendNow(form) {
    if (form.__dtPosting) return;
    form.__dtPosting = true; clearInterval(form.__dtGuard);
    if (!form.__dtSending) setSending(form, true);
    var action = (form.getAttribute('action') || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact').split('#')[0];
    fetch(action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (/contact_posted=true/.test(r.url)) return true;
        return r.text().then(function (html) { return /contact_posted=true/.test(html) && !/class="[^"]*errors/.test(html); });
      })
      .then(function (ok) { finishSend(form, ok); }, function () { finishSend(form, false); });
  }
  function finishSend(form, ok) {
    var c = (teamCfg() || { dataset: {} }).dataset, st = form.querySelector('[data-dt-status]');
    form.__dtPosting = false; clearInterval(form.__dtGuard); setSending(form, false);
    if (ok) {
      var kind = form.getAttribute('data-dt-cform'), sh = form.closest('[data-dt-sheet]'), done = sh && sh.querySelector('[data-dt-done]');
      if (st) st.textContent = '';
      form.reset(); form.hidden = true; if (done) { done.hidden = false; done.focus(); }
      track(kind === 'callback' ? 'callback_requested' : 'contact_form_submitted');
      instances.forEach(function (ch) {
        var note = document.createElement('div'); note.className = 'dt-chat__added dt-chat__sent'; note.setAttribute('role', 'status');
        note.innerHTML = '<span>' + svg('check') + esc(c.sentNote || '') + '</span>'; ch.log.appendChild(note); ch.log.scrollTop = ch.log.scrollHeight;
      });
    } else if (st) {
      st.textContent = c.sendError || 'Versturen lukte niet.'; st.classList.add('is-error');
      var waLbl = document.querySelector('[data-dt-team-tpl]');
      waLbl = waLbl && waLbl.content.querySelector('.dt-team__btn--wa .dt-team__lbl');
      if (waLbl && waUrl()) { var wb = document.createElement('button'); wb.type = 'button'; wb.className = 'dt-team__btn dt-team__btn--wa dt-cform__wa'; wb.setAttribute('data-dt-contact', 'whatsapp'); wb.textContent = waLbl.textContent; st.appendChild(document.createTextNode(' ')); st.appendChild(wb); }
    }
  }
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-dt-cform]')) return;
    bindSubmit(form);
    if (form.__dtPosting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    fill(form);
    if (!validate(form)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    setSending(form, true);
    if (form.getAttribute('data-hcaptcha-bound')) {
      // Shopify's captcha-script neemt het over en roept daarna sendNow aan. Was het formulier al gekoppeld vóór ons
      // (zeldzaam), dan verstuurt Shopify zelf en gaat de bezoeker naar Shopify's bevestiging: ook goed.
      if (!form.__dtLateBind) guard(form);
      return;
    }
    // captcha-script nog niet geladen: even wachten tot Shopify het formulier koppelt en dan opnieuw indienen
    e.preventDefault(); e.stopImmediatePropagation();
    var tries = 0, w = setInterval(function () {
      tries++;
      if (form.getAttribute('data-hcaptcha-bound')) { clearInterval(w); setSending(form, false); if (form.requestSubmit) form.requestSubmit(); else sendNow(form); }
      else if (tries > 20) { clearInterval(w); sendNow(form); }
    }, 150);
  }, true);
  document.addEventListener('input', function (e) {
    var el = e.target; if (el && el.getAttribute && el.getAttribute('aria-invalid') === 'true') fieldError(el, '');
  });

  function markNudged() {
    try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (e) {}
    var b = document.querySelector('[data-dt-badge]'); if (b) b.hidden = true;
    var t = document.querySelector('[data-dt-teaser]'); if (t && !t.hidden) { t.classList.remove('is-in'); setTimeout(function () { t.hidden = true; }, 250); }
  }
  function initNudge() {
    var c = teamCfg(), fab = document.querySelector('.dt-chat-fab'); if (!c || !fab) return;
    try { if (sessionStorage.getItem(NUDGE_KEY) === '1') return; } catch (e) {}
    var badge = fab.querySelector('[data-dt-badge]'), teaser = document.querySelector('[data-dt-teaser]');
    if (badge && c.dataset.badge === 'true') setTimeout(function () { if (!opened) badge.hidden = false; }, 8000);
    // 27-10-2026: tekstwolkje naast Tufty blijft staan tot de bezoeker het sluit; op mobiel (smal scherm) na 12 s weg.
    if (teaser) setTimeout(function () {
      if (opened || document.documentElement.classList.contains('dt-chat-open')) return;
      try { if (sessionStorage.getItem(NUDGE_KEY) === '1') return; } catch (e) {}
      teaser.hidden = false; requestAnimationFrame(function () { teaser.classList.add('is-in'); });
      if (window.matchMedia && window.matchMedia('(max-width: 699px)').matches) {
        setTimeout(function () { if (!teaser.hidden) markNudged(); }, 12000);  // één keer per bezoek
      }
    }, Math.max(1, +c.dataset.teaserDelay || 2) * 1000);
  }

  function closeDialog() {
    if (!dialog || dialog.hidden) return;
    hideSheet(true);
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('dt-chat-open');
    tuftySync();
    setTimeout(function () { dialog.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openAssistant(prefill, forcePopup) {
    var inline = !forcePopup && document.querySelector('[data-dt-chat-inline]');
    if (inline) {
      inline.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = inline.querySelector('[data-dt-input]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); if (prefill) input.value = prefill; }, 450);
      return;
    }
    openDialog();
  }
  document.addEventListener('click', function (e) {
    var yes = e.target.closest('[data-dt-helped-yes]');
    if (yes) {
      e.preventDefault();
      setHelped('yes');
      var ybox = yes.closest('[data-dt-helped]');
      if (ybox) ybox.remove();
      return;
    }
    var no = e.target.closest('[data-dt-helped-no]');
    if (no) {
      e.preventDefault();
      setHelped('no');
      var nbox = no.closest('[data-dt-helped]');
      var hc = (teamCfg() && teamCfg().dataset) || {};
      var strip = teamStrip({ heading: hc.humanHeading || 'Liever een mens spreken?' });
      if (nbox && strip) { strip.classList.add('dt-team--msg'); nbox.replaceWith(strip); }
      else if (nbox) nbox.remove();
      return;
    }
    var c = e.target.closest('[data-dt-contact]');
    if (c) { e.preventDefault(); contact(c.getAttribute('data-dt-contact')); return; }
    if (e.target.closest('[data-dt-teaser-close]')) { e.preventDefault(); markNudged(); return; }
    var tr = e.target.closest('[data-dt-track]'); if (tr) track(tr.getAttribute('data-dt-track'));
    if (e.target.closest('[data-dt-sheet-close]')) { e.preventDefault(); hideSheet(); return; }
    var t = e.target.closest('a[href*="#tufting-assistent"], [data-dt-open-chat]');
    if (t) { e.preventDefault(); openAssistant(t.dataset.dtPrefill, !!t.closest('.dt-chat-fab, .dt-chat-teaser')); return; }
    if (e.target.closest('[data-dt-chat-close]')) { e.preventDefault(); closeDialog(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !dialog || dialog.hidden) return;
    if (activeSheet) hideSheet(); else closeDialog();
  });
  if (location.hash === '#tufting-assistent') setTimeout(function () { openAssistant(); }, 400);

  window.DTChat = { init: init, open: openAssistant, closeDialog: closeDialog, contact: contact, sendForm: sendNow };
  function boot() { init(); initNudge(); armTufty(document); decorateHelpTufty(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('visibilitychange', function () { tuftySync(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); armTufty(); decorateHelpTufty(); });
})();
